import { useEffect, useState } from "react";
import styled from "styled-components";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Box,
  Autocomplete,
  IconButton,
  Typography,
} from "@mui/material";
import { createFilterOptions } from "@mui/material/Autocomplete";
import Dialog from "src/components/core/Dialog";
import Button from "src/components/core/Button";
import TextField from "src/components/core/TextField";

import CloseIcon from "@mui/icons-material/Close";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import SellerIcon from "src/components/icon/Seller";

import font from "src/styles/font";
import { Black, Grey, White01 } from "src/styles/color";
import { useDialog } from "src/context/DialogContext";
import { useSnackbar } from "notistack";

import { getSellerNotDeal, addSeller } from "src/api/deal";

const WrapperTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: ${font.size.md};
  font-weight: 500;
  color: ${Black};
`

const WrapperTextfield = styled.div`
  width: 100%;

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 16px;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .MuiAutocomplete-root {
    margin: 0;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    /* border-radius: 16px; */
    padding: 16px;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 16px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 16px;
  }

  .MuiTextField-root {
    border-radius: 16px;
  }
  .MuiOutlinedInput-root {
    border-radius: 16px;
  }
  .MuiInputAdornment-root {
    font-size: ${font.size.sm};
    color: ${Grey};
  }
`;

const ImageEmpty = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;
  margin-right: 8px;
  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;

const ImgDisplay = styled.img`
  width: 56px;
  height: 56px;
  object-fit: cover;
  object-position: center;
  border-radius: 8px;
  flex-shrink: 0;
`;

const WrapperSeletedSeller = styled.div`
  width: 100%;
  max-width: 216px;
  position: relative;
  padding-top: 216px;
  margin: 24px auto 0;
  background-color: ${White01};
  border-radius: 16px;
`

const EmptySeller = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const EmptySellerSpan = styled.span`
  color: ${Grey};
  font-size: ${font.size.sm};
  font-weight: 400;
  user-select: none;
`

const PreviewSeller = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${(props) => props.backgroundImg});
  background-size: cover;
  background-position: center;
  border-radius: inherit;
`

const AddSellerDialog = ({ onClose, onSuccess }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { openDialog } = useDialog();

  const [sellers, setSellers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // ? Not confirm
  const [selectedSeller, setSelectedSeller] = useState();

  const isFormValid = selectedSeller?._id;

  const fetchSellers = async () => {
    try {
      setIsLoading(true);
      const { data } = await getSellerNotDeal();
      if (!!data) {
        setSellers(data);
        setIsLoading(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = async () => {
    try {
      await addSeller({ seller_id: selectedSeller._id });

      enqueueSnackbar(`เพิ่มร้านค้าที่เข้าร่วมสำเร็จ`, {
        variant: "success",
      });

      onSuccess();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSellers();
  }, []);

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={true}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: 1024,
            maxWidth: "100%",
          },
        },
        "& .MuiDialogContent-root": {
          pt: 1,
          pb: 4,
        },
      }}
    >
      <DialogTitle sx={{ p: 3 }}>
        <WrapperTitle>
          <SellerIcon size={24} />
          เพิ่มร้านค้าที่เข้าร่วม
        </WrapperTitle>
        
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <WrapperTextfield>
          <Autocomplete
            // freeSolo
            aria-required={true}
            // getOptionSelected={(option, value) =>
            //   option?._id === value?._id
            // }
            isOptionEqualToValue={(option, value) =>
              option?._id === value?._id
            }
            renderOption={(props, option, { selected }) => (
              <li
                {...props}
                key={`item-${option?._id}`}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {!!option?.profile_image === false ? (
                    <ImageEmpty>
                      <InsertPhotoIcon
                        sx={{
                          color: "rgba(0, 0, 0, 0.54)",
                          cursor: "pointer",
                        }}
                      />
                    </ImageEmpty>
                  ) : (
                    <ImgDisplay
                      src={
                        option?.profile_image
                          ? option?.profile_image
                          : ""
                      }
                      alt={option?.profile_image}
                    />
                  )}
                  <Stack style={{ marginLeft: 16 }}>
                    <Typography component="span">
                      {option?.brand_name}
                    </Typography>
                  </Stack>
                </Box>
              </li>
            )}
            options={sellers}
            value={selectedSeller}
            onChange={(e, newValue) => {
              setSelectedSeller(newValue)
            }}
            loading={isLoading}
            getOptionLabel={(option) => {
              return option?.brand_name || "--";
            }}
            filterOptions={createFilterOptions({
              matchFrom: "any",
              limit: 100,
            })}
            sx={{
              width: "100%",
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{
                  maxWidth: "100%",
                  width: "100%",
                }}
                required
                placeholder="ค้นหาร้านค้า"
                error={!selectedSeller?._id ? true : false}
              />
            )}
          />
        </WrapperTextfield>

        <WrapperSeletedSeller>
          {!selectedSeller?._id ? (
            <EmptySeller>
              <EmptySellerSpan>ยังไม่ได้เลือกร้านค้า</EmptySellerSpan>
            </EmptySeller>
          ) : (
            <>
            {!selectedSeller?.profile_image ? (
              <PreviewSeller>
                <ImageEmpty>
                  <InsertPhotoIcon
                    sx={{
                      color: "rgba(0, 0, 0, 0.54)",
                      cursor: "pointer",
                    }}
                  />
                </ImageEmpty>
              </PreviewSeller>
            ) : (
              <PreviewSeller
                backgroundImg={selectedSeller?.profile_image}
              />
            )}
            </>
          )}
        </WrapperSeletedSeller>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
        }}
      >
        <Button
          variant="outlined"
          size="large"
          onClick={onClose}
          sx={{
            minWidth: 160,
          }}
        >
          ยกเลิก
        </Button>
        <Button
          variant="contained"
          size="large"
          onClick={() => {
            openDialog({
              type: "confirm",
              title: `คุณต้องการเพิ่มร้านค้าใช่หรือไม่`,
              onConfirm: () => {
                handleSubmit();
              },
              maxWidth: 342,
            });
          }}
          sx={{
            minWidth: 160,
          }}
          // autoFocus // enable auto focus to increase accessibility
          disabled={!isFormValid}
        >
          เพิ่ม
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddSellerDialog;
